// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewSensorySessionId } from './BrewSensorySession';
import { brewSensoryQuestionId } from './BrewSensoryQuestion';
import { brewSensoryCategory } from './BrewSensoryCategory';
import { foodSensoryQuestionType } from './FoodSensoryQuestionType';
import { brewSensoryFormId } from './BrewSensoryForm';
import { z } from 'zod';
export const brewSensorySessionQuestionId = (z.number());
export const brewSensorySessionQuestion = z.object({
    id: brewSensorySessionQuestionId,
    brew_sensory_session_id: brewSensorySessionId,
    source_question_id: brewSensoryQuestionId.nullable(),
    category: brewSensoryCategory,
    text: z.string(),
    question_type: foodSensoryQuestionType,
    options: z.unknown().nullable(),
    min_value: z.number(),
    max_value: z.number(),
    min_label: z.string().nullable(),
    max_label: z.string().nullable(),
    display_order: z.number(),
    required: z.boolean(),
    created_at: z.date(),
    is_acceptance: z.boolean(),
    source_form_id: brewSensoryFormId.nullable(),
    source_form_name: z.string().nullable(),
});
export const brewSensorySessionQuestionInitializer = z.object({
    id: brewSensorySessionQuestionId.optional(),
    brew_sensory_session_id: brewSensorySessionId,
    source_question_id: brewSensoryQuestionId.optional().nullable(),
    category: brewSensoryCategory,
    text: z.string(),
    question_type: foodSensoryQuestionType,
    options: z.unknown().optional().nullable(),
    min_value: z.number().optional(),
    max_value: z.number().optional(),
    min_label: z.string().optional().nullable(),
    max_label: z.string().optional().nullable(),
    display_order: z.number().optional(),
    required: z.boolean().optional(),
    created_at: z.date().optional(),
    is_acceptance: z.boolean().optional(),
    source_form_id: brewSensoryFormId.optional().nullable(),
    source_form_name: z.string().optional().nullable(),
});
export const brewSensorySessionQuestionMutator = z.object({
    id: brewSensorySessionQuestionId.optional(),
    brew_sensory_session_id: brewSensorySessionId.optional(),
    source_question_id: brewSensoryQuestionId.optional().nullable(),
    category: brewSensoryCategory.optional(),
    text: z.string().optional(),
    question_type: foodSensoryQuestionType.optional(),
    options: z.unknown().optional().nullable(),
    min_value: z.number().optional(),
    max_value: z.number().optional(),
    min_label: z.string().optional().nullable(),
    max_label: z.string().optional().nullable(),
    display_order: z.number().optional(),
    required: z.boolean().optional(),
    created_at: z.date().optional(),
    is_acceptance: z.boolean().optional(),
    source_form_id: brewSensoryFormId.optional().nullable(),
    source_form_name: z.string().optional().nullable(),
});
//# sourceMappingURL=BrewSensorySessionQuestion.js.map